import React, { useState, useRef, useEffect } from "react";
import "./ClientJobsCard.css";
import { ExperienceIcon } from "../../Icons/ExperienceIcon";
import { AddressIcon } from "../../Icons/AddressIcon";
import { EndClient } from "../../Icons/EndClient";
import { FaSyncAlt } from "react-icons/fa";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const ClientJobsCard = ({ job, onClick }) => {
  const { jobDetails = {}, associatedApplicatsStatus = {} } = job || {};

  const {
    jobTitle = "",
    jobCode = "",
    clientName = "",
    jobType = "",
    location = "",
    workModel = "",
    endClient = "",
    status = "",
  } = jobDetails;

  const statsEntries = Object.entries(associatedApplicatsStatus).filter(
    ([key]) => key !== "id",
  );

  const [openModal, setOpenModal] = useState(false);
  const [showViewMore, setShowViewMore] = useState(false);
  const statsContainerRef = useRef(null);

  useEffect(() => {
    if (statsContainerRef.current) {
      // Check if content overflows the max-height of 2 rows
      const hasOverflow =
        statsContainerRef.current.scrollHeight >
        statsContainerRef.current.clientHeight;
      setShowViewMore(hasOverflow);
    }
  }, [statsEntries]);

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  const storedTheme = JSON.parse(localStorage.getItem("themeSettings")) || "";

  return (
    <div className="client-jobs-card" onClick={onClick} style={{ cursor: "pointer" }}>
      <div className="card-header-wrapper">
        <div className="job-title-badge">
          <div className="job-title-text-container">
            <span className="job-title-text-truncate">{jobTitle}</span>
            <span className="job-code-text">({jobCode})</span>
          </div>
        </div>
        <div className="job-status-text">{status}</div>
      </div>

      <div className="card-content">
        <h3 className="client-display-name">{clientName || "-"}</h3>

        <div className="detail-row">
          <div className="icon-container">
            <ExperienceIcon primaryFontColor={"#1a1a1a"} />
          </div>
          <div className="detail-info">
            <span className="detail-label">Job Type:</span>
            <span className="detail-value">{jobType || "-"}</span>
          </div>
        </div>

        <div className="detail-row">
          <div className="icon-container">
            <AddressIcon primaryFontColor={"#1a1a1a"} />
          </div>
          <div className="detail-info">
            <span className="detail-label">Location:</span>
            <span className="detail-value">{location || "-"}</span>
          </div>
        </div>

        <div className="detail-row">
          <div className="icon-container">
            <FaSyncAlt
              className="sync-icon"
              color={"#1a1a1a"}
              size={16}
            />
          </div>
          <div className="detail-info">
            <span className="detail-label">Work Model:</span>
            <span className="detail-value">{workModel || "-"}</span>
          </div>
        </div>

        <div className="detail-row">
          <div className="icon-container">
            <EndClient primaryFontColor={"#1a1a1a"} />
          </div>
          <div className="detail-info">
            <span className="detail-label">End Client:</span>
            <span className="detail-value">{endClient || "-"}</span>
          </div>
        </div>

        <div className="stats-section">
          <p className="stats-header">APPLICANTS STATUS</p>
          <div
            className="stats-grid-container"
            style={{ position: "relative" }}
          >
            <div
              className={`stats-grid ${showViewMore ? "has-overflow" : ""}`}
              ref={statsContainerRef}
            >
              {statsEntries && statsEntries.length > 0 ? (
                statsEntries.map(([key, value]) => (
                  <div className="stat-pill" key={key}>
                    <span className="stat-count">{value}</span>
                    <span className="stat-label">
                      {key.charAt(0).toUpperCase() +
                        key.slice(1).replace("_", " ")}
                    </span>
                  </div>
                ))
              ) : (
                <div className="">{"-"}</div>
              )}
            </div>
            {showViewMore && (
              <div className="view-more-container">
                <span className="view-more-link" onClick={handleOpenModal}>
                  View More
                </span>
              </div>
            )}
          </div>
        </div>
      </div>

      <Dialog
        open={openModal}
        onClose={handleCloseModal}
        maxWidth="xs"
        fullWidth
        className="status-dialog"
        PaperProps={{
          style: {
            borderRadius: "12px",
            overflow: "hidden",
          },
        }}
      >
        <DialogTitle className="status-dialog-title">
          All Applicants Statuses - {jobCode}
          <IconButton
            aria-label="close"
            onClick={handleCloseModal}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: "#ff0000ff",
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent className="status-dialog-content">
          <Box className="status-list">
            {statsEntries.map(([key, value]) => (
              <div className="status-row" key={key}>
                <span className="status-label">
                  {key.charAt(0).toUpperCase() + key.slice(1).replace("_", " ")}
                </span>
                <span className="status-value">{value}</span>
              </div>
            ))}
          </Box>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default ClientJobsCard;
